var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropositionArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.028,
    height: 98.785,
    viewBox: "0 0 39.028 98.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17328",
    "data-name": "Group 17328",
    transform: "translate(-227.7 -260.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16887",
    "data-name": "Group 16887",
    transform: "matrix(1, 0.017, -0.017, 1, -859.301, -167.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M38.57.057c.005,3.278.135,18.836.039,24.293s1.434,4.861-12.849,4.84L.047,29.152",
    transform: "matrix(0.017, 1, -1, 0.017, 1127.051, 411.824)",
    fill: "none",
    stroke: "#bdc4cb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "matrix(0.017, 1, -1, 0.017, 1101.385, 408.729)",
    fill: "#fff",
    stroke: "#bdc4cb",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.541,
    cy: 3.541,
    rx: 3.541,
    ry: 3.541,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.541,
    cy: 3.541,
    rx: 2.541,
    ry: 2.541,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M0,0,5.336,3.557,0,7.114Z",
    transform: "matrix(1, -0.017, 0.017, 1, 1127.666, 446.984)",
    fill: "#bdc4cb",
    stroke: "#bdc4cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17327",
    "data-name": "Group 17327",
    transform: "matrix(1, 0.017, -0.017, 1, -860.382, -115.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M58.215.057c.008,3.278.2,18.836.06,24.293s2.165,4.861-19.4,4.84L.047,29.152",
    transform: "matrix(0.017, 1, -1, 0.017, 1127.707, 392.145)",
    fill: "none",
    stroke: "#bdc4cb",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M0,0,5.336,3.557,0,7.114Z",
    transform: "matrix(1, -0.017, 0.017, 1, 1127.666, 446.984)",
    fill: "#bdc4cb",
    stroke: "#bdc4cb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropositionArrow);
export default __webpack_public_path__ + "static/media/proposition_arrow.e4401dc65229925bc2b74c6eba755f67.svg";
export { ForwardRef as ReactComponent };